import { useMutation, useQuery } from "@apollo/client";
import {
  Card,
  CardSection,
  Container,
  Grid,
  Loading,
  Typography,
  Button,
  Hidden,
} from "@pmberjaya/cloudbank-ui";
import React, { useState, useEffect } from "react";

import { useCookies } from "react-cookie";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import {
  CREATE_TEMPORARY_AFFILIATION,
  CREATE_TEMPORARY_RESELLER,
  USER_INFO,
} from "../../../gql/user";
import Section from "../Section";

const FormPartner = (props) => {
  const { title, paragraf, type, idMobile, idDesktop } = props;
  const [cookie] = useCookies();
  const [countryCode, setCountryCode] = useState();
  const { data: dataUser } = useQuery(USER_INFO);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [createData, { loading, error }] = useMutation(
    type === 1 ? CREATE_TEMPORARY_RESELLER : CREATE_TEMPORARY_AFFILIATION,
    {
      onCompleted: () => {
        alert(
          "Akun berhasil didaftarkan! Admin kami akan menghubungi Anda untuk proses lebih lanjut!"
        );
      },
      onError: (resp) => {
        toast(resp.message, {
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_LEFT,
        });
      },
    }
  );

  const [dataReseller, setDataReseller] = useState({
    name: "",
    email: "",
    phone: "",
    phone_code: "+62",
  });

  useEffect(() => {
    if (cookie.access_token !== undefined && dataUser) {
      setDataReseller({
        ...dataReseller,
        name: dataUser?.me.name,
        email: dataUser?.me.email,
        phone:
          dataUser?.me.phone === null || dataUser?.me.phone === ""
            ? null
            : dataUser?.me.phone.split(".")[1],
        phone_code:
          dataUser?.me.phone === null || dataUser?.me.phone === ""
            ? "+62"
            : dataUser?.me.phone.split(".")[0],
      });
    }
    // eslint-disable-next-line
  }, [dataUser]);

  useEffect(() => {
    fetch(
      "https://gist.githubusercontent.com/Goles/3196253/raw/9ca4e7e62ea5ad935bb3580dc0a07d9df033b451/CountryCodes.json"
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setCountryCode(result);
        },
        (error) => {
          console.log(error);
        }
      );
    // eslint-disable-next-line
  }, [dataUser]);

  const handleCreateData = () => {
    if (
      dataReseller.name === "" ||
      dataReseller.email === "" ||
      dataReseller.phone === ""
    ) {
      alert("Mohon mengisi data yang diperlukan!");
    } else {
      createData({
        variables: {
          input: {
            name: dataReseller.name,
            email: dataReseller.email,
            phone: dataReseller.phone_code + "." + dataReseller.phone,
          },
        },
      });
    }
  };
  return (
    <Section>
      <Hidden smDown>
        <div id={idDesktop}>
          <Container className="bg-primary mt-5 form-partner">
            <Grid row alignItems="center" justifyContent="center">
              <Grid md={6} className="">
                <Typography color="light" className="text-heading-h3">
                  {title}
                </Typography>
                <Typography
                  color="light "
                  className={`text-paragraf ${isMobile ? "mt-5" : ""}`}
                >
                  {paragraf}
                </Typography>
              </Grid>
              <Grid xs={12} md={5}>
                <Card
                  className={`mt-5 pt-3 px-4 box-shadow-card `}
                  borderColor="light"
                >
                  <CardSection>
                    <Typography
                      className="text-heading-h3"
                      textTransform="capitalize"
                      color="primary"
                    >
                      {" "}
                      Daftar sekarang
                    </Typography>
                    <div className="input-group-lg mt-5">
                      <input
                        value={dataReseller?.name}
                        placeholder="Nama Lengkap"
                        className="form-control px-3"
                        onChange={(event) =>
                          setDataReseller({
                            ...dataReseller,
                            name: event.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="input-group-lg  mt-4 pt-3">
                      <input
                        value={dataReseller?.email}
                        type="email"
                        placeholder="Email"
                        className="form-control px-3"
                        onChange={(event) =>
                          setDataReseller({
                            ...dataReseller,
                            email: event.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="input-group input-group-lg mt-4 pt-3">
                      {countryCode === undefined ? (
                        <Loading />
                      ) : (
                        <select
                          className="full-width-64 form-control me-3"
                          value={dataReseller.phone_code}
                          onChange={(e) =>
                            setDataReseller({
                              ...dataReseller,
                              phone_code: e.target.value,
                            })
                          }
                        >
                          {countryCode.map((row) => (
                            <option value={row.dial_code}>
                              {row.dial_code}({row.name})
                            </option>
                          ))}
                        </select>
                      )}
                      <input
                        className="form-control"
                        placeholder="Nomor Telepon"
                        type="number"
                        value={dataReseller?.phone}
                        onChange={(event) =>
                          setDataReseller({
                            ...dataReseller,
                            phone: event.target.value,
                          })
                        }
                      />
                    </div>
                    <Grid xs={6} className="mt-5  mx-auto">
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                        disabled={loading || error}
                        onClick={handleCreateData}
                      >
                        Daftar
                      </Button>
                    </Grid>
                  </CardSection>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </div>
      </Hidden>

      <Hidden smUp>
        <div className="bg-primary mt-5 form-partner" id={idMobile}>
          <Container>
            <Grid xs={12}>
              <Typography
                color="light"
                variant="h3"
                className="text-heading-h3 pt-5"
              >
                {title}
              </Typography>
              <Typography color="light " className={`text-paragraf  mt-5 pb-5`}>
                {paragraf}
              </Typography>
            </Grid>
          </Container>
        </div>
        <Container>
          <Grid xs={12}>
            <Card
              className={`mt-5 pt-3 px-4 box-shadow-card `}
              borderColor="light"
            >
              <CardSection>
                <Typography
                  variant="h3"
                  className="text-heading-h3"
                  textTransform="capitalize"
                  color="primary"
                >
                  {" "}
                  Daftar sekarang
                </Typography>
                <div className="input-group-lg mt-5">
                  <input
                    value={dataReseller?.name}
                    placeholder="Nama Lengkap"
                    className="form-control px-3"
                    onChange={(event) =>
                      setDataReseller({
                        ...dataReseller,
                        name: event.target.value,
                      })
                    }
                  />
                </div>
                <div className="input-group-lg  mt-4 pt-3">
                  <input
                    value={dataReseller?.email}
                    type="email"
                    placeholder="Email"
                    className="form-control px-3"
                    onChange={(event) =>
                      setDataReseller({
                        ...dataReseller,
                        email: event.target.value,
                      })
                    }
                  />
                </div>
                <div className="input-group input-group-lg mt-4 pt-3">
                  {countryCode === undefined ? (
                    <Loading />
                  ) : (
                    <select
                      className="form-control me-3 full-width-64"
                      value={dataReseller.phone_code}
                      onChange={(e) =>
                        setDataReseller({
                          ...dataReseller,
                          phone_code: e.target.value,
                        })
                      }
                    >
                      {countryCode.map((row) => (
                        <option value={row.dial_code}>
                          {row.dial_code}({row.name})
                        </option>
                      ))}
                    </select>
                  )}
                  <input
                    className="form-control"
                    placeholder="Nomor Telepon"
                    type="number"
                    value={dataReseller?.phone}
                    onChange={(event) =>
                      setDataReseller({
                        ...dataReseller,
                        phone: event.target.value,
                      })
                    }
                  />
                </div>
                <Grid xs={6} className="mt-5  mx-auto">
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    disabled={loading || error}
                    onClick={handleCreateData}
                  >
                    Daftar
                  </Button>
                </Grid>
              </CardSection>
            </Card>
          </Grid>
        </Container>
      </Hidden>
    </Section>
  );
};

export default FormPartner;
